<template>
  <div :class="$attrs.class" class="form-group w-full">
    <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules" v-bind="$attrs">
      <label v-if="label" :class="labelClass" class="block text-base font-normal mb-1">{{ label }}<b
          v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b></label>
      <div class="relative input-group">
        <div v-if="leftIcon" class="icon-left"><i :class="leftIcon"></i></div>
        <input :type="type"
               :class="['form-control', leftIcon ? 'pl-10' : '', rightIcon ? 'pr-10' : '', inputClass]"
               :value="innerValue"
               autocomplete="off" v-bind="$attrs" @input="onChange">
        <div v-if="rightIcon" class="icon-right"><i :class="rightIcon"></i></div>
        <slot name="right-icon"></slot>
      </div>
      <span class="text-xs text-red-600">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    value: [String, Number],
    label: String,
    leftIcon: String,
    rightIcon: String,
    labelClass: [String, Array],
    inputClass: [String, Array],
    rules: String,
    name: String,
    type: {
      type: String,
      default: "time"
    }
  },
  data() {
    return {
      // modelData: ""
    }
  },
  computed: {
    isRequired() {
      return this.required || this.rules?.search("required") > -1;
    },
    innerValue(){
      let val = this.value;
      const fullTimeRegx = /^\d\d:\d\d:\d\d$/;
      if (fullTimeRegx.test(val)) {
        val = val.substring(0, val.length - 3)
      }
      return val;
    }
  },
  methods: {
    onChange(e) {
      let val = e.target.value;
      const timeRegx = /^\d\d:\d\d$/;
      if (timeRegx.test(val)) {
        val += ":00";
      }
      this.$emit("input", val);
    }
  }
}
</script>
